
export class DesaparecidoGamDto {
	documento: string;
	complemento: string | null;
	nombres: string;
	apellidoPaterno: string;
	apellidoMaterno: string;
	colorOjos: string;
	colorCabellos: string;
	sexo: string;
	departamento: string;
	nacionalidad: string;
	fechaNacimiento: string;
	fechaDesaparicion: string;
	horaDesaparicion: string;
	peso: string;
	tez: string;
	estatura: string;
	vestimenta: string;
	//senias: string;
	resumen: string;
	lugarHecho: string;
	encontrado: boolean;
	municipio: string;
	referencia: string;
}